exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner-container {\r\n    position: relative; \r\n    height: 200px;\r\n}\r\n\r\n.banner-title {\r\n    position: absolute; \r\n    z-index: 1000; \r\n    left: 0;\r\n    bottom: 0; \r\n    right: 0;\r\n    width: 100%; \r\n    background-color: rgba(0,0,0,0.5); \r\n    text-align: center;\r\n    height: auto; \r\n    padding: 10px; \r\n    color: #fff; \r\n    pointer-events: none;\r\n}\r\n\r\n", ""]);

// exports
